import React, { useEffect, useState, useMemo, useRef } from "react";
import FileUpload from "../FileUpload";
import {
  RouteUser,
  SectionWrapper,
  ContentDataUser,
  OptionWrapper,
  ButtonUserCancel,
  ButtonUserCreate,
  ContentSaveUserButtons,
  TitleUserModule,
  TextTitleUser,
  ContainerBulkUpload,
  InfoBulkUpload,
  ContentPreviewBulk,
  ButtonDownloadTemplate,
  SectionWrapperLob,
  ContentLob,
  ContentSelectAll,
  SearchLob,
  ContentAddAccountButtons,
  ButtonAddAccount,
  ContentAddAccountSection,
  TitleAddAccount,
  ContentFieldsAddAccount,
  ButtonDeleteAccount,
} from "./CreateUser.styled";

import PersonIcon from "@material-ui/icons/Person";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import imgInfo from "../../assets/imgInfo.png";
import downloadFile from "../../assets/downloadFile.png";
import { NotificationManager } from "react-notifications";
import MaterialTable from "material-table";
import { getTemplateExcelFile } from "../../services/ExcelFileManager";
import { Col, Row } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { ROLES } from "../../util/RolesConstants";
import BackButtonComponent from "../BackButtonComponent/BackButtonComponent";
import { toCamelCaseFirstLetter } from "../../util/UtilityFunctions";
import PropTypes from "prop-types";
import MultiplesTenantSelector from "../MultiplesTenantSelector/MultiplesTenantSelector";

const CreateUser = ({
  action,
  setFormTrigger,
  profiles,
  countries,
  cities,
  countryListAccount,
  citiesListAccount,
  allLobsByCountry,
  allLobsByCountryAccount,
  EditUser,
  getCities,
  createUserNew,
  updateUserOld,
  getCountriesAccount,
  getCitiesAccount,
  bulkUploadUsersMessage,
  createNewAccount,
  updateAccount,
  showAddAccount,
  superVisorList,
  superVisorListAccount,
  setGetComoNoComo,
  clientList,
  handleDeleteAccount,
  formsAddAccount,
  setFormsAddAccount,
  formsEditAccount,
  getComoNoComoAccount,
  handleGetClients,
  getLobsAccount,
}) => {
  const [renderAgain, setRenderAgain] = useState(false);
  const userComplete = useMemo(() => getStateLoginComplete(), []);
  const selectAll = useRef();
  const profile = useRef();
  const username = useRef(null);
  const name = useRef();
  const email = useRef();
  const usermail = useRef();
  const lastname = useRef();
  const country = useRef();
  const city = useRef();
  const rsupervisor = useRef();
  const comonocomo = useRef();
  const [lobs, setLobs] = useState([]);
  const [lobsAccount, setLobsAccount] = useState([]);
  const [filterLobs, setFilterLobs] = useState("");
  const [filterLobsAccount, setFilterLobsAccount] = useState("");
  const [editModified, setEditModified] = useState(false);
  const [activeUser, setActiveUser] = useState(
    action === "edit" ? EditUser.enabled : true
  );
  const [dataBulkUpload, setDataBulkUpload] = useState([]);
  const [dataBulkUploadTable, setDataBulkUploadTable] = useState([]);
  const [files, setFiles] = useState({});
  const titleAddAccount = useMemo(() => "Additional Account Assignment", []);
  const [additionalTenants, setAdditionalTenants] = useState([]);
  const rClient = useRef(null);
  const rRoleAccount = useRef(null);
  const rCountryAccount = useRef(null);
  const rCityAccount = useRef(null);
  const rSupervisorAccount = useRef(null);
  const rComoNoComoAccount = useRef(null);
  const rLobsAccount = useRef(null);

  const [clientListAvailables, setClientListAvailables] = useState([]);

  const [tpIdSelected, setTpIdSelected] = useState();

  const [limitOfForms, setLimitOfForms] = useState(null);
  const [formsAddedCounter, setFormsAddedCounter] = useState(null)

  const comoNoComo = [
    {
      name: "Como",
      id: "1",
    },
    {
      name: "No Como",
      id: "2",
    },
  ];

  const comoNoComoAccount = [
    {
      name: "Como",
      id: "1",
    },
    {
      name: "No Como",
      id: "2",
    },
  ];

  const removeSpace = (obj) => {
    obj.ref.current.value = obj.ref.current.value.replace(/ /g, "");
    setRenderAgain(!renderAgain);
  };

  const getComoNoComo = (id) => {
    if (id === "1") {
      setGetComoNoComo(true);
    } else if (id === "2") {
      setGetComoNoComo(false);
    } else {
      setGetComoNoComo(null);
    }
  };

  const fields = [
    {
      type: "select",
      label: "Role",
      ref: profile,
      fn: setRenderAgain,
      data: profiles,
      mandatory: true,
    },
    {
      type: "text",
      label: "User Name",
      ref: username,
      fn: setRenderAgain,
      placeholder: "Please enter a User name",
      mandatory: true,
    },
    {
      type: "text",
      label: "Tp Id",
      ref: email,
      fn: setRenderAgain,
      placeholder: "Please enter your Tp Id",
      regexp: /^[^@]+@[^@]+\.[A-Z]+$/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "First Name",
      ref: name,
      fn: setRenderAgain,
      placeholder: "Please enter a name",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Last Name",
      ref: lastname,
      fn: setRenderAgain,
      placeholder: "Please enter a last name",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Email",
      ref: usermail,
      fn: removeSpace,
      placeholder: "Please enter your Email",
      regexp: /^[^@]+@[^@]+\.[A-Z]+$/i,
      mandatory: true,
    },
    {
      type: "select",
      label: "Country",
      ref: country,
      fn: getCities,
      data: countries,
      mandatory: true,
    },
    {
      type: "select",
      label: "City",
      ref: city,
      fn: setRenderAgain,
      data: cities,
      mandatory: true,
    },
    {
      type: "select",
      label: "Users Supervisor",
      ref: rsupervisor,
      fn: setRenderAgain,
      data: superVisorList,
      mandatory: false,
    },
    {
      type: "select",
      label: "Como/Non Como",
      ref: comonocomo,
      fn: getComoNoComo,
      data: comoNoComo,
      mandatory: false,
    },
  ];

  const fieldsAddAccount = [
    {
      type: "select",
      label: "Client Account",
      ref: rClient,
      name: "client",
      fn: getCountriesAccount,
      data: clientList,
      placeholder: "Select a Client",
      mandatory: true,
    },
    {
      type: "select",
      label: "Role Account",
      ref: rRoleAccount,
      name: "role",
      fn: setRenderAgain,
      data: profiles,
      placeholder: "Select a Role",
      mandatory: true,
    },
    {
      type: "select",
      label: "Country Account",
      ref: rCountryAccount,
      name: "country",
      fn: getCitiesAccount,
      data: countryListAccount,
      placeholder: "Select a Country",
      mandatory: true,
    },
    {
      type: "select",
      label: "City Account",
      ref: rCityAccount,
      name: "city",
      fn: setRenderAgain,
      data: citiesListAccount,
      placeholder: "Select a City",
      mandatory: true,
    },
    {
      type: "select",
      label: "Users Supervisor Account",
      ref: rSupervisorAccount,
      name: "supervisor",
      fn: setRenderAgain,
      data: superVisorListAccount,
      placeholder: "Select a Supervisor",
    },
    {
      type: "select",
      label: "Como/Non Como Account",
      ref: rComoNoComoAccount,
      name: "isCoMoUser",
      fn: getComoNoComoAccount,
      data: comoNoComoAccount,
      placeholder: "Select a Como/Non Como",
    },
  ];

  const goToBackPage = () => {
    setFormTrigger("");
  };

  const handleCheckLobs = (obj) => {
    let pos = lobs.findIndex((x) => x === obj.lobId);
    if (pos === -1) {
      lobs.push(obj.lobId);
    } else {
      lobs.splice(pos, 1);
    }
    setDataBulkUpload([]);
    setFiles({});
  };

  const handleCheckLobsAccount = (obj) => {
    let pos = lobsAccount.findIndex((x) => x === obj.lobId);
    if (pos === -1) {
      lobsAccount.push(obj.lobId);
    } else {
      lobsAccount.splice(pos, 1);
    }
    setDataBulkUpload([]);
    setFiles({});
  };

  const getEmail = (obj) => {
    obj.ref.current.value = obj.ref.current.value.replace(/ /g, "");
    // setGetEmail(value)
  };

  const execFunction = (obj) => {
    setEditModified(true);
    switch (obj.label) {
      case "Country":
        city.current.value = "0";
        obj.fn(obj.ref.current.value);
        break;
      case "City":
        obj.fn(obj.ref.current.value);
        break;
      case "Users Supervisor":
        obj.fn(obj.ref.current.value);
        break;
      case "Como/Non Como":
        obj.fn(obj.ref.current.value);
        break;
      default:
        break;
    }

    setDataBulkUpload([]);
    setFiles({});
  };

  const execFunctionAccount = (obj) => {
    switch (obj.label) {
      case "Client Account":
        rCountryAccount.current.value = "0";
        rCityAccount.current.value = "0";
        obj.fn(obj.ref.current.value);
        break;
      case "Country Account":
        rCityAccount.current.value = "0";
        getLobsAccount(obj.ref.current.value, rClient.current.value);
        obj.fn(obj.ref.current.value, rClient.current.value);
        break;
      case "City Account":
        obj.fn(obj.ref.current.value);
        break;
      case "Users Supervisor Account":
        obj.fn(obj.ref.current.value);
        break;
      case "Como/Non Como Account":
        obj.fn(obj.ref.current.value);
        break;
      default:
        break;
    }
  };

  const handleCancelAddAccount = (item) => {
    const newForms = formsAddAccount.filter((form) => form !== item);
    setFormsAddAccount(newForms);
  };

  const validateData = (fields) => {
    let data = {};
    let missingData = false;
    let errorData = false;
    for (let index = 0; index < fields.length; index++) {
      if (
        (fields[index].mandatory &&
          fields[index].type === "select" &&
          fields[index].ref.current.value === "0") ||
        (fields[index].type === "text" &&
          fields[index].ref.current.value === "")
      ) {
        if (files && action === "upload") {
          missingData = false;
        } else {
          missingData = true;
        }
        break;
      } else if (
        (fields[index].label === "Email" &&
          fields[index].regexp &&
          !fields[index].regexp.test(fields[index].ref.current.value)) ||
        (fields[index].label === "Tp Id" &&
          fields[index].ref.current.value &&
          !/^[^@]+@[^@]+\.[A-Z]+$/i.test(fields[index].ref.current.value))
      ) {
        errorData = true;
        break;
      } else {
        data[fields[index].label.replaceAll(" ", "")] =
          fields[index].ref.current.value;
      }
      if (index === fields.length - 1) {
        if (lobs.length) {
          data["lobs"] = lobs;
        } else {
          missingData = true;
        }
      }
    }
    if (!missingData && !errorData) {
      data["active"] = activeUser;
      setTpIdSelected(data.TpId);
      if (action === "add") {
        let countryName =
          countries[
            countries.findIndex((item) => item.id === parseInt(data.Country))
          ].countryName;
        createUserNew(data, countryName);
      } else if (action === "edit") {
        updateUserOld(data, EditUser.userId);
      } else if (action === "upload") bulkUploadUsersMessage(data, files);
      return;
    }
    if (errorData)
      NotificationManager.warning("there are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  const validateDataNewAccount = (fieldsAccount, type) => {
    let data = {};
    let missingData = false;
    let errorData = false;
    for (let index = 0; index < fieldsAccount.length; index++) {
      if (
        (fieldsAccount[index].mandatory &&
          fieldsAccount[index].type === "select" &&
          fieldsAccount[index].ref.current.value === "0") ||
        (fieldsAccount[index].type === "text" &&
          fieldsAccount[index].ref.current.value === "")
      ) {
        if (files && action === "upload") {
          missingData = false;
        } else {
          missingData = true;
        }
        break;
      } else if (
        (fieldsAccount[index].label === "Email" &&
          fieldsAccount[index].regexp &&
          !fieldsAccount[index].regexp.test(
            fieldsAccount[index].ref.current.value
          )) ||
        (fieldsAccount[index].label === "Tp Id" &&
          fieldsAccount[index].ref.current.value &&
          !/^[^@]+@[^@]+\.[A-Z]+$/i.test(
            fieldsAccount[index].ref.current.value
          ))
      ) {
        errorData = true;
        break;
      } else {
        data[fieldsAccount[index].label.replaceAll(" ", "")] =
          fieldsAccount[index].ref.current.value;
      }
      if (index === fieldsAccount.length - 1) {
        if (lobsAccount.length) {
          data["lobsAccount"] = lobsAccount;
        } else {
          missingData = true;
        }
      }
    }
    if (!missingData && !errorData) {
      data["active"] = activeUser;
      data["tpid"] = tpIdSelected;
      if (action === "add" || type === "add") {
        createNewAccount(data);
      } else if (action === "edit" && type === "edit") {
        updateAccount(data);
      }
      return;
    }
    if (errorData)
      NotificationManager.warning("There are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  const handleSelectAllLobs = () => {
    if (selectAll.current.checked) {
      let lobsAll = [];
      allLobsByCountry.lobsListByCountry.map((l, i) => {
        lobsAll.push(l.lobId);
        setLobs(lobsAll);
      });
    } else {
      setLobs([]);
    }
  };

  const handleSelectAllLobsAccount = (e) => {
    if (e.target.checked) {
      let lobsAll = [];
      allLobsByCountryAccount.lobsListByCountry.map((l, i) => {
        lobsAll.push(l.lobId);
        setLobsAccount(lobsAll);
      });
    } else {
      setLobsAccount([]);
    }
  };

  const handleAddAccount = () => {
    setFormsAddAccount([...formsAddAccount, ""]);
  };

  const handleAddFormToEdit = (items) => {
    items.forEach((element) => {
      handleGetClients(userComplete.clientId);
      getCountriesAccount(element.location.clientId);
      getLobsAccount(element.location.countryId, element.location.clientId);
      getCitiesAccount(element.location.countryId, element.location.clientId);
      element.lobs.map((m) => {
        lobsAccount.push(m.lobId);
      });
      formsEditAccount.push("");
    });
  };

  useEffect(() => {
    if (formsAddAccount?.length > 0) {
      setFormsAddedCounter(formsAddAccount.length)
    }
  }, [formsAddAccount])

  useEffect(() => {
    let data = [];
    if (dataBulkUpload.length) {
      let newFile = JSON.parse(dataBulkUpload[0]);
      newFile.map((m) => {
        let obj = m;
        let regex = /(\d+)/g;
        let lobSelected1 = obj["LOB1"] ? obj["LOB1"].split("-")[1] : "";
        let lobSelected2 = obj["LOB2"] ? obj["LOB2"].split("-")[1] : "";
        let lobSelected3 = obj["LOB3"] ? obj["LOB3"].split("-")[1] : "";
        let lobSelected4 = obj["LOB4"] ? obj["LOB4"].split("-")[1] : "";
        let lobSelected5 = obj["LOB5"] ? obj["LOB5"].split("-")[1] : "";
        let match = obj["Role"]?.match?.(regex);
        if (!match) {
          console.warn("Invalid role in row:", obj["Role"]);
        }
        let roleSelected = profiles?.filter?.(
          (f) => f.id === parseInt(match?.[0] ?? "")
        );
        let dto = {
          FirstName: obj["FirstName"] ? obj["FirstName"] : "NA",
          LastName: obj["LastName"] ? obj["LastName"] : "NA",
          CCMSUsername: obj["CCMSUsername"] ? obj["CCMSUsername"] : "NA",
          Email: obj["Email Address"] ? obj["Email Address"] : "NA",
          City: obj["City"] ? obj["City"] : "NA",
          Role: roleSelected?.length ? roleSelected[0].name : "NA",
          TPID: obj["TPID"] ? obj["TPID"] : "NA",
          LOB1: lobSelected1 ? lobSelected1 : "NA",
          LOB2: lobSelected2 ? lobSelected2 : "NA",
          LOB3: lobSelected3 ? lobSelected3 : "NA",
          LOB4: lobSelected4 ? lobSelected4 : "NA",
          LOB5: lobSelected5 ? lobSelected5 : "NA",
          AllLOBs: obj["All-LOB's"] ? obj["All-LOB's"] : "NA",
          ActiveUser: obj["Active User"] ? obj["Active User"] : "NA",
          ComoNonComo:
            obj["Is Content Moderator"] === "1 - Yes" ? "Como" : "Non Como",
          Supervisor: obj["Supervisor TPID"] ? obj["Supervisor TPID"] : "NA",
        };
        data.push(dto);
      });
    }
    const isValidName = data.every((x) => {
      const firstName = x.FirstName.toString();
      const lastName = x.LastName.toString();
      const regex = /\d+/g;
      return !firstName.match(regex) && !lastName.match(regex);
    });
    if (isValidName) {
      setDataBulkUploadTable(data);
    } else {
      NotificationManager.warning(
        "Firstname and lastname should not have any numbers.",
        "",
        5000
      );
      setFiles([]);
    }
  }, [dataBulkUpload, profile]);

  useEffect(() => {
    if (Array.isArray(clientListAvailables)) {
      setLimitOfForms(clientListAvailables.length);
    }
  }, [clientListAvailables]);

  useEffect(() => {
    if (action === "edit") {
      username.current.value = EditUser?.userCcms.toString();
      username.current.disabled = true;
      email.current.value = EditUser?.userTpId.toString();
      usermail.current.value = EditUser?.userEmail.toString();
      name.current.value = EditUser?.userFirstName.toString();
      lastname.current.value = EditUser?.userLastName.toString();
      EditUser &&
        EditUser?.lobs.map((m) => {
          lobs.push(m.lobId);
        });
      if (EditUser?.additionalTenants.length > 0) {
        setAdditionalTenants(EditUser?.additionalTenants);
      }
    }
  }, [EditUser, action]);

  useEffect(() => {
    if (
      Array.isArray(additionalTenants) &&
      additionalTenants.length > 0 &&
      action === "edit"
    ) {
      handleAddFormToEdit(additionalTenants);
    }
  }, [additionalTenants]);

  useEffect(() => {
    if (Array.isArray(clientList) && Array.isArray(additionalTenants)) {
      setClientListAvailables(clientList.filter(client => {
        return !additionalTenants.some(additionalTenant => additionalTenant.clientId === client.clientId);
      }));
    }
  }, [clientList, additionalTenants])

  useEffect(() => {
    if (
      action === "edit" &&
      !editModified &&
      EditUser.supervisorId &&
      EditUser.supervisorId !== null
    ) {
      rsupervisor.current.value = EditUser?.supervisorId;
    }
  }, [superVisorList]);

  useEffect(() => {
    if (action === "edit" && !editModified) {
      // User information
      profile.current.value = EditUser?.role.roleId
        ? EditUser.role.roleId.toString()
        : "0";
      country.current.value = EditUser?.location.countryId.toString();
      city.current.value = EditUser?.location.cityId.toString();
      comonocomo.current.value =
        EditUser?.isCoMoUser === true
          ? "1"
          : EditUser?.isCoMoUser === false
            ? "2"
            : "0";
    }
  }, [profiles, countries, cities, comoNoComo]);

  const renderInputs = (obj, index) => {
    switch (obj.type) {
      case "select":
        return (
          <SectionWrapper hidden={obj.hidden} key={index}>
            <label>
              {obj.label}
              {obj.mandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <select
              ref={obj.ref}
              name={obj.name}
              onChange={() => execFunction(obj)}
            >
              <option value={0}>--- Select an option ---</option>

              {obj.data.map((p, i) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>

            {obj.ref.current && obj.ref.current.value !== "0" && (
              <CheckIcon
                style={{
                  color: "white",
                  background: "rgba(51, 207, 141, 1)",
                  borderRadius: "36px",
                  fontSize: "13px",
                  margin: "0px 3px",
                }}
              />
            )}
          </SectionWrapper>
        );
      case "text":
        if (
          action === "upload" &&
          (obj.label.includes("Name") || obj.label.includes("Email"))
        ) {
          return null;
        }
        return (
          <SectionWrapper hidden={obj.hidden} key={index}>
            <label>
              {obj.label}
              {obj.mandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              type="text"
              placeholder={obj.placeholder}
              onChange={(e) => {
                if (["First Name", "Last Name"].includes(obj.label)) {
                  obj.ref.current.value = e.target.value.replace(/\d+/g, ""); // Remove numbers
                }
                if (obj.label === "Email" || obj.label === "Tp Id") {
                  obj.ref.current.value = e.target.value.replace(/\s+/g, ""); // Remove spaces
                }
                obj.label === "Email" ? obj.fn(obj) : obj.fn(!renderAgain);
              }}
              ref={obj.ref}
              title={
                (obj.label === "Country" || obj.label === "Country Account") &&
                "Three letter country code"
              }
            />
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label === "Email" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label === "Tp Id" &&
                  obj.regexp.test(obj.ref.current.value))) && (
                <CheckIcon
                  style={{
                    color: "white",
                    background: "rgba(51, 207, 141, 1)",
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}

            {obj.ref.current && obj.ref.current.value && !obj.regexp && (
              <CheckIcon
                style={{
                  color: "white",
                  background: "rgba(51, 207, 141, 1)",
                  borderRadius: "36px",
                  fontSize: "13px",
                  margin: "0px 3px",
                }}
              />
            )}
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label !== "Email" &&
                obj.label !== "Tp Id" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label === "Email" &&
                  !obj.regexp.test(obj.ref.current.value)) ||
                (obj.label === "Tp Id" &&
                  !obj.regexp.test(obj.ref.current.value))) && (
                <CloseIcon
                  style={{
                    color: "white",
                    background: "rgb(241 3 3)",
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
          </SectionWrapper>
        );
      default:
        break;
    }
  };

  const renderEditForms = (data) => {
    return formsEditAccount.map((form, formIndex) => (
      <ContentAddAccountSection key={formsAddAccount.length + 1}>
        <TitleAddAccount>{titleAddAccount}</TitleAddAccount>
        <ContentFieldsAddAccount>
          {fieldsAddAccount.map((f, index) =>
            <MultiplesTenantSelector key={index} obj={f} index={index} data={data} formIndex={formIndex} execFunctionAccount={execFunctionAccount} />
          )}
          <SectionWrapperLob>
            <ContentSelectAll>
              <div
                className="lob-selectall"
                style={{ float: "left", marginTop: "4px" }}
              >
                <label>
                  LOB <span style={{ color: "red" }}> *</span>
                </label>
              </div>
              <OptionWrapper>
                <input
                  ref={rLobsAccount}
                  type="checkbox"
                  onChange={(e) => handleSelectAllLobsAccount(e)}
                  checked={
                    lobsAccount.length ===
                    (allLobsByCountryAccount &&
                      Array.isArray(
                        allLobsByCountryAccount?.lobsListByCountry
                      ) &&
                      allLobsByCountryAccount.lobsListByCountry.length)
                  }
                />{" "}
                <label>Select all</label>
              </OptionWrapper>
              <SearchLob>
                <label>Search Current LOBs :</label>
                <input
                  type="text"
                  placeholder="Please enter the name Lob"
                  onChange={(e) => setFilterLobsAccount(e.target.value)}
                />
              </SearchLob>
            </ContentSelectAll>
            <ContentLob>
              {Array.isArray(allLobsByCountryAccount) &&
                allLobsByCountryAccount?.lobsListByCountry?.length === 0 && (
                  <p style={{ width: "50vw" }}>
                    No records found for the country selected.Please create a
                    LOB for the selected country.
                  </p>
                )}
              {Array.isArray(allLobsByCountryAccount) &&
                allLobsByCountryAccount?.lobsListByCountry?.length === 0 && (
                  <p style={{ width: "50vw" }}>
                    No records found for the country selected.Please create a
                    LOB for the selected country.
                  </p>
                )}
              {Array.isArray(allLobsByCountryAccount?.lobsListByCountry) &&
                allLobsByCountryAccount?.lobsListByCountry
                  .filter(
                    (f) =>
                      f.enabled &&
                      f.lobName
                        .toUpperCase()
                        .includes(filterLobsAccount.toUpperCase())
                  )
                  .slice()
                  .sort((a, b) => (a.lobName > b.lobName ? 1 : -1))
                  .map((l, i) => {
                    return (
                      <OptionWrapper key={i}>
                        <input
                          type="checkbox"
                          onChange={() => handleCheckLobsAccount(l)}
                          checked={
                            lobsAccount.findIndex((f) => f === l.lobId) > -1
                              ? true
                              : false
                          }
                        />{" "}
                        <label>{l.lobName}</label>
                      </OptionWrapper>
                    );
                  })}
            </ContentLob>
          </SectionWrapperLob>
        </ContentFieldsAddAccount>
        <ContentSaveUserButtons action={action}>
          <ButtonUserCreate
            onClick={() => {
              validateDataNewAccount(fieldsAddAccount, "edit");
            }}
          >
            Update Account
          </ButtonUserCreate>
          <ButtonDeleteAccount
            onClick={() =>
              handleDeleteAccount(data[formIndex], formsAddAccount.length + 1)
            }
          >
            <DeleteIcon /> Delete Additional Account
          </ButtonDeleteAccount>
        </ContentSaveUserButtons>
      </ContentAddAccountSection>
    ));
  };

  const renderForms = () => {
    return formsAddAccount.map((form) => (
      <ContentAddAccountSection key={formsAddAccount.length + 1}>
        <TitleAddAccount>{titleAddAccount}</TitleAddAccount>
        <ContentFieldsAddAccount>
          {fieldsAddAccount.map((f, index) =>
            <MultiplesTenantSelector key={index} obj={f} index={index} execFunctionAccount={execFunctionAccount} />
          )}
          <SectionWrapperLob>
            <ContentSelectAll>
              <div
                className="lob-selectall"
                style={{ float: "left", marginTop: "4px" }}
              >
                <label>
                  LOB <span style={{ color: "red" }}> *</span>
                </label>
              </div>
              <OptionWrapper>
                <input
                  ref={rLobsAccount}
                  type="checkbox"
                  onChange={(e) => handleSelectAllLobsAccount(e)}
                  checked={
                    lobsAccount.length ===
                    (allLobsByCountryAccount &&
                      Array.isArray(
                        allLobsByCountryAccount?.lobsListByCountry
                      ) &&
                      allLobsByCountryAccount.lobsListByCountry.length)
                  }
                />{" "}
                <label>Select all</label>
              </OptionWrapper>
              <SearchLob>
                <label>Search Current LOBs :</label>
                <input
                  type="text"
                  placeholder="Please enter the name Lob"
                  onChange={(e) => setFilterLobsAccount(e.target.value)}
                />
              </SearchLob>
            </ContentSelectAll>
            <ContentLob>
              {Array.isArray(allLobsByCountryAccount) &&
                allLobsByCountryAccount?.lobsListByCountry?.length === 0 && (
                  <p style={{ width: "50vw" }}>
                    No records found for the country selected.Please create a
                    LOB for the selected country.
                  </p>
                )}
              {Array.isArray(allLobsByCountryAccount) &&
                allLobsByCountryAccount?.lobsListByCountry?.length === 0 && (
                  <p style={{ width: "50vw" }}>
                    No records found for the country selected.Please create a
                    LOB for the selected country.
                  </p>
                )}
              {Array.isArray(allLobsByCountryAccount?.lobsListByCountry) &&
                allLobsByCountryAccount?.lobsListByCountry
                  .filter(
                    (f) =>
                      f.enabled &&
                      f.lobName
                        .toUpperCase()
                        .includes(filterLobsAccount.toUpperCase())
                  )
                  .slice()
                  .sort((a, b) => (a.lobName > b.lobName ? 1 : -1))
                  .map((l, i) => {
                    return (
                      <OptionWrapper key={i}>
                        <input
                          type="checkbox"
                          onChange={() => handleCheckLobsAccount(l)}
                          checked={
                            lobsAccount.findIndex((f) => f === l.lobId) > -1
                              ? true
                              : false
                          }
                        />{" "}
                        <label>{l.lobName}</label>
                      </OptionWrapper>
                    );
                  })}
            </ContentLob>
          </SectionWrapperLob>
        </ContentFieldsAddAccount>
        <ContentSaveUserButtons action={action}>
          <ButtonUserCancel onClick={() => setFormTrigger("")}>
            Cancel
          </ButtonUserCancel>
          <ButtonUserCreate
            onClick={() => {
              validateDataNewAccount(fieldsAddAccount, "add");
            }}
          >
            Create Account
          </ButtonUserCreate>
        </ContentSaveUserButtons>
      </ContentAddAccountSection>
    ));
  };

  return (
    <>
      <RouteUser>
        <BackButtonComponent
          backtitle={"Site Management"}
          locationtitle={
            action === "upload"
              ? "Update template"
              : toCamelCaseFirstLetter(action) + " User"
          }
          goToBackPage={goToBackPage}
        />
      </RouteUser>
      <TitleUserModule>
        {(action === "add" || action === "edit") && (
          <TextTitleUser>
            <PersonIcon /> {action} User
          </TextTitleUser>
        )}
      </TitleUserModule>

      <ContentDataUser hidden={action === "upload"}>
        {fields.map((f, index) => renderInputs(f, index))}

        <SectionWrapperLob>
          <ContentSelectAll>
            <div
              className="lob-selectall"
              style={{ float: "left", marginTop: "4px" }}
            >
              <label>
                LOB <span style={{ color: "red" }}> *</span>
              </label>
            </div>
            <OptionWrapper>
              <input
                ref={selectAll}
                type="checkbox"
                onChange={(e) => handleSelectAllLobs()}
                checked={
                  lobs.length ===
                  (allLobsByCountry &&
                    Array.isArray(allLobsByCountry?.lobsListByCountry) &&
                    allLobsByCountry.lobsListByCountry.length)
                }
              />{" "}
              <label>Select all</label>
            </OptionWrapper>
            <SearchLob>
              <label>Search Current LOBs :</label>
              <input
                type="text"
                placeholder="Please enter the name Lob"
                onChange={(e) => setFilterLobs(e.target.value)}
              />
            </SearchLob>
          </ContentSelectAll>
          <ContentLob>
            {Array.isArray(allLobsByCountry) &&
              allLobsByCountry?.lobsListByCountry?.length === 0 && (
                <p style={{ width: "50vw" }}>
                  No records found for the country selected.Please create a LOB
                  for the selected country.
                </p>
              )}
            {Array.isArray(allLobsByCountry) &&
              allLobsByCountry?.lobsListByCountry?.length === 0 && (
                <p style={{ width: "50vw" }}>
                  No records found for the country selected.Please create a LOB
                  for the selected country.
                </p>
              )}
            {Array.isArray(allLobsByCountry?.lobsListByCountry) &&
              allLobsByCountry?.lobsListByCountry
                .filter(
                  (f) =>
                    f.enabled &&
                    f.lobName.toUpperCase().includes(filterLobs.toUpperCase())
                )
                .slice()
                .sort((a, b) => (a.lobName > b.lobName ? 1 : -1))
                .map((l, i) => {
                  return (
                    <OptionWrapper key={i}>
                      <input
                        type="checkbox"
                        onChange={() => handleCheckLobs(l)}
                        checked={
                          lobs.findIndex((f) => f === l.lobId) > -1
                            ? true
                            : false
                        }
                      />{" "}
                      <label>{l.lobName}</label>
                    </OptionWrapper>
                  );
                })}
          </ContentLob>
        </SectionWrapperLob>

        <OptionWrapper
          hidden={action === "edit" ? false : true}
          style={{ marginLeft: "10px" }}
        >
          <input
            type="checkbox"
            onClick={(e) => {
              setActiveUser(!activeUser);
              setDataBulkUpload([]);
              setFiles({});
            }}
            defaultChecked={activeUser}
          />{" "}
          <label>Active User</label>
        </OptionWrapper>
      </ContentDataUser>

      {action === "upload" && (
        <>
          <TitleUserModule>
            <TextTitleUser>1. Download template</TextTitleUser>
          </TitleUserModule>
          <InfoBulkUpload>
            <Row>
              <Col
                md={3}
                className="d-flex justify-content-around align-items-center"
              >
                <ButtonDownloadTemplate
                  onClick={() => {
                    getTemplateExcelFile();
                  }}
                >
                  <img src={downloadFile} alt="" /> Download template here
                </ButtonDownloadTemplate>
              </Col>
              <Col md={6} className="d-flex mt-3 align-items-center">
                <ul>
                  <li>
                    <img src={imgInfo} style={{ width: "6px" }} alt="" /> You
                    can upload .xlsx files separated by Commas (,)
                  </li>
                  <li>
                    <img src={imgInfo} style={{ width: "6px" }} alt="" />{" "}
                    Maximum weight 7Mb
                  </li>
                  <li>
                    <img src={imgInfo} style={{ width: "6px" }} alt="" /> Only
                    200 records will be displayed in the preview
                  </li>
                  <li>
                    <img src={imgInfo} style={{ width: "6px" }} alt="" /> The
                    firstname and the lastname in the records should not contain
                    any numbers
                  </li>
                </ul>
              </Col>
            </Row>
          </InfoBulkUpload>
          <TitleUserModule>
            <TextTitleUser>2. Upload Template</TextTitleUser>
          </TitleUserModule>
          <ContainerBulkUpload>
            <div className="FileUploadContainer" style={{ width: "370px" }}>
              <FileUpload
                accept=".xlsx"
                label="Profile Image(s)"
                // multiple
                setDataBulkUpload={setDataBulkUpload}
                setFiles={setFiles}
                files={files}
              />
            </div>
          </ContainerBulkUpload>
        </>
      )}

      {dataBulkUploadTable.length > 0 && (
        <>
          <TitleUserModule>
            <TextTitleUser>
              {action === "upload" ? "3." : "2."} Preview
            </TextTitleUser>
          </TitleUserModule>
          <ContentPreviewBulk>
            <MaterialTable
              title="Users to upload"
              columns={[
                {
                  title: "First Name",
                  field: "FirstName",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Last Name",
                  field: "LastName",
                  type: "string",
                  headerStyle: {
                    padding: "0px 1px",
                  },
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "CCMS Username",
                  field: "CCMSUsername",
                  type: "string",
                  headerStyle: {
                    padding: "0px 1px",
                  },
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Email",
                  field: "Email",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "City",
                  field: "City",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Role",
                  field: "Role",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "TPID",
                  field: "TPID",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Supervisor",
                  field: "Supervisor",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Como/Non Como",
                  field: "ComoNonComo",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "LOB1",
                  field: "LOB1",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "LOB2",
                  field: "LOB2",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "LOB3",
                  field: "LOB3",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "LOB4",
                  field: "LOB4",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "LOB5",
                  field: "LOB5",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "All-LOB's",
                  field: "AllLOBs",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Active User",
                  field: "ActiveUser",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
              ]}
              data={dataBulkUploadTable}
              options={{
                maxBodyHeight: 450,
                headerStyle: {
                  zIndex: 1,
                  fontWeight: "bold",
                },
                cellStyle: {
                  padding: "5px 10px",
                },
              }}
            ></MaterialTable>
          </ContentPreviewBulk>
        </>
      )}

      <ContentSaveUserButtons>
        <ButtonUserCancel onClick={() => setFormTrigger("")}>
          Cancel
        </ButtonUserCancel>
        <ButtonUserCreate
          onClick={() => {
            if (action === "upload") {
              return validateData(
                fields.filter(
                  (f) => !f.label.includes("Name") && !f.label.includes("Email")
                )
              );
            } else {
              return validateData(fields);
            }
          }}
        >
          {action === "add" && action !== "edit" ? "Save User" : ""}
          {action === "edit" && action !== "add" ? "Update User" : ""}
          {action !== "edit" && action !== "add" ? "Upload User" : ""}
        </ButtonUserCreate>
      </ContentSaveUserButtons>
      {userComplete.roleId === ROLES.SUPER_ADMIN &&
        renderEditForms(additionalTenants)}
      {userComplete.roleId === ROLES.SUPER_ADMIN && renderForms()}
      {showAddAccount &&
        userComplete.roleId === ROLES.SUPER_ADMIN &&
        (formsAddedCounter < limitOfForms) && (
          <ContentAddAccountButtons>
            <ButtonAddAccount onClick={() => handleAddAccount()}>
              + Add Account
            </ButtonAddAccount>
          </ContentAddAccountButtons>
        )}
    </>
  );
};

export default CreateUser;

CreateUser.propTypes = {
  action: PropTypes.string,
  setFormTrigger: PropTypes.func,
  profiles: PropTypes.array,
  countries: PropTypes.array,
  cities: PropTypes.array,
  countryListAccount: PropTypes.array,
  citiesListAccount: PropTypes.array,
  allLobsByCountry: PropTypes.array,
  allLobsByCountryAccount: PropTypes.array,
  EditUser: PropTypes.object,
  getCities: PropTypes.func,
  createUserNew: PropTypes.func,
  updateUserOld: PropTypes.func,
  getCountriesAccount: PropTypes.func,
  getCitiesAccount: PropTypes.func,
  bulkUploadUsersMessage: PropTypes.func,
  createNewAccount: PropTypes.func,
  updateAccount: PropTypes.func,
  showAddAccount: PropTypes.bool,
  superVisorList: PropTypes.array,
  superVisorListAccount: PropTypes.array,
  setGetComoNoComo: PropTypes.func,
  clientList: PropTypes.array,
  handleDeleteAccount: PropTypes.func,
  formsAddAccount: PropTypes.array,
  setFormsAddAccount: PropTypes.func,
  formsEditAccount: PropTypes.array,
  getComoNoComoAccount: PropTypes.func,
  handleGetClients: PropTypes.func,
  getLobsAccount: PropTypes.func,
};
